export default {
	sX: 276,
	sY: 0,
	w: 224,
	h: 112,
	x: 0,
	y: function (game) {
        return game.canvas.ground.height - this.h
    },

	dx: 2,

	draw: function (game) {
		game.ctx.ground.drawImage(
			game.sprite,
			this.sX,
			this.sY,
			this.w,
			this.h,
			this.x,
			this.y(game),
			this.w,
			this.h
		);

		game.ctx.ground.drawImage(
			game.sprite,
			this.sX,
			this.sY,
			this.w,
			this.h,
			this.x + this.w,
			this.y(game),
			this.w,
			this.h
		);

		game.ctx.ground.drawImage(
			game.sprite,
			this.sX,
			this.sY,
			this.w,
			this.h,
			this.x + (this.w * 2),
			this.y(game),
			this.w,
			this.h
		);
	},

	update: function (game) {
		if (game.state.current == game.state.game) {
			this.x = (this.x - this.dx) % (this.w);
		}
	},
}